import { useApiQuery } from '../../hooks/use-api';
import { Client } from './api'; // Re-using the client type

export function useClientDetail(clientId: string) {
  const endpoint = `/clients/${clientId}`;
  return useApiQuery<Client>(['clients', clientId], endpoint, { enabled: !!clientId });
}

// Placeholder for client session history
export function useClientSessionHistory(clientId: string) {
  const endpoint = `/sessions?clientId=${clientId}&limit=5`;
  return useApiQuery<any>(['sessions', 'history', clientId], endpoint, { enabled: !!clientId });
}